import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal, { SectionHead } from "./Reveal";

const FAQS = [
    {
        q: "WHAT IS $BALD?",
        a: "$BALD is a community-driven memecoin on Solana centered around the BALD PIGEON meme.",
    },
    { q: "WHAT IS THE TOTAL SUPPLY?", a: "1,000,000,000 $BALD." },
    {
        q: "WHERE CAN I BUY $BALD?",
        a: "Use the official links provided on this website and always verify the contract address before trading.",
    },
    {
        q: "WHAT IS THE CONTRACT ADDRESS?",
        a: "9b2TErku1jM8gd2DFVotGyXMdmPx2fcwvBuHPzqQpump",
    },
    {
        q: "IS $BALD A GUARANTEED INVESTMENT?",
        a: "No. $BALD is a highly speculative memecoin. There are no guarantees of profit or future value.",
    },
    {
        q: "WHAT IS THE BUY & BURN?",
        a: "A portion of Creator Rewards may be allocated to buying $BALD and burning the purchased tokens. Burn transactions can be verified on-chain.",
    },
];

export default function Faq() {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" data-testid="faq-section" className="relative scroll-mt-24 py-24 lg:py-32">
            <div className="mx-auto max-w-3xl px-4 sm:px-6">
                <SectionHead kicker="FAQ" title="FREQUENTLY ASKED QUESTIONS" />
                <div className="mt-12 space-y-3">
                    {FAQS.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={f.q} delay={i * 0.06}>
                                <div
                                    data-testid={`faq-item-${i + 1}`}
                                    className={`glass overflow-hidden rounded-2xl transition-colors ${
                                        isOpen ? "border-cyan-400/40" : ""
                                    }`}
                                >
                                    <button
                                        type="button"
                                        data-testid={`faq-question-${i + 1}`}
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        className="flex w-full items-center justify-between gap-4 p-5 text-left md:p-6"
                                        aria-expanded={isOpen}
                                    >
                                        <span className="font-bold uppercase tracking-wide text-white">{f.q}</span>
                                        <Plus
                                            className={`h-5 w-5 shrink-0 text-cyan-300 transition-transform duration-300 ${
                                                isOpen ? "rotate-45" : ""
                                            }`}
                                        />
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.3, ease: [0.19, 1, 0.22, 1] }}
                                            >
                                                <p className="px-5 pb-5 text-slate-400 md:px-6 md:pb-6" data-testid={`faq-answer-${i + 1}`}>
                                                    {f.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
